import { createAction } from '@wix/communities-blog-client-common';

export const SET_MAIN_POST = 'mainPost/SET';
export const setMainPost = createAction(SET_MAIN_POST);
